import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import type { ToastProps } from '../../components/Toast';
import { IS_EXTENSION } from '../../constants/platform';
import { UIActions } from '../../ui/uiSlice';

export type ToastContent =
  | ((options: { onDismiss: () => void }) => ReactNode)
  | Omit<ToastProps, 'onDismiss'>;

const useShowEditorToast = IS_EXTENSION
  ? () => () => {}
  : () => {
      const dispatch = useAppDispatch();

      return useCallback(
        (content: ToastContent, duration?: number) => {
          dispatch(UIActions.pushToast(content, duration));
        },
        [dispatch],
      );
    };

export default useShowEditorToast;
